export default __webpack_public_path__ + "static/media/logo_evermaps_white.3732a005.png";